import { render, staticRenderFns } from "./QR.vue?vue&type=template&id=3078c8ce&scoped=true"
import script from "./QR.vue?vue&type=script&lang=js"
export * from "./QR.vue?vue&type=script&lang=js"
import style0 from "./QR.vue?vue&type=style&index=0&id=3078c8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3078c8ce",
  null
  
)

export default component.exports